var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReconfigurationBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.208 5.54199L16.3747 7.70866L14.208 9.87533",
    stroke: "#00729D",
    strokeWidth: 1.06,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 10.958V9.87467C6.625 9.30004 6.85327 8.74894 7.2596 8.34261C7.66593 7.93628 8.21703 7.70801 8.79167 7.70801H16.375",
    stroke: "#00729D",
    strokeWidth: 1.06,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79167 17.4583L6.625 15.2917L8.79167 13.125",
    stroke: "#00729D",
    strokeWidth: 1.06,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.375 12.042V13.1253C16.375 13.7 16.1467 14.2511 15.7404 14.6574C15.3341 15.0637 14.783 15.292 14.2083 15.292H6.625",
    stroke: "#00729D",
    strokeWidth: 1.06,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconfigurationBanner);
export default __webpack_public_path__ + "static/media/ReconfigurationBanner.85f011fc64316a68ef990e044e894476.svg";
export { ForwardRef as ReactComponent };